import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureOperationalContent } from '../utils/infrastructureContent';

export const useInfrastructureOperationalContent = () =>
  useInfrastructureSectionContent(parseInfrastructureOperationalContent);
